import React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import { Dialog, DialogContent, TextField } from '@mui/material';
import { DataGrid, GridColumns } from '@mui/x-data-grid';
import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';

interface LinkMemberComponentProps {
  toggleDialog: (show: boolean) => void;
  show: boolean;
  columns: GridColumns;
  handleMemberSearch: any;
  // members: Member[];
  members: any[]
}

function PaperComponent(props: PaperProps) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const LinkMemberComponent = (props: LinkMemberComponentProps) => {
  const { show, toggleDialog, columns, handleMemberSearch, members } = props;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query: string = event.target.value;
    if (query.length >= 3) {
      handleMemberSearch(query);
    }
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={'md'}
      open={show}
      onClose={() => toggleDialog(false)}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
    >
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        Link Member to EFT Record
      </DialogTitle>
      <DialogContent>
        <TextField
          size="small"
          fullWidth
          id="search-member"
          label="Search by Order reference, Member Wallet address, email, first or last name"
          variant="outlined"
          onChange={handleChange}
        />
        <div style={{ height: 720 }}>
          <span />
          <DataGrid rows={members} columns={columns} pageSize={10} rowsPerPageOptions={[10]} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LinkMemberComponent;
